import affirm from '../Affirm'

/**
 * This class is used to abstract away all calls that are non-deterministic.
 * As of now they just return non-deterministic values, but in the future the implementation can be easily replaced with deterministic code
 */
class DeterministicSimulationTestingEngine {
    _options: IDSTEOptions

    init = (options: IDSTEOptions) => {
        affirm(options, 'Invalid options')
        this._options = options
    }

    /**
     * returns a random number between 0 and 1
     */
    random = (): number => Math.random()

    now = (): Date => new Date()
}

/**
 * Deterministic Simulation Testing Engine
 */
const DSTE = new DeterministicSimulationTestingEngine()
DSTE.init({ seed: 0 }) // this is going to bite me in the butt...
export default DSTE

export interface IDSTEOptions {
    seed: number
}
